import { FilterType } from 'types';
import { useAppDispatch } from 'redux/hooks';
import { setFilters } from 'actionCreators';

/**
 * Use `useTablePagination`
 *
 * @deprecated
 */
const useMuiTablePaginate = ({
  filter,
  totalSoFar,
  fetchMoreAction,
}: {
  filter: FilterType;
  totalSoFar: number;
  fetchMoreAction: ({ newPage, newOffset }: { newPage: number; newOffset: number }) => void;
}) => {
  const dispatch = useAppDispatch();

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => {
    const newOffset = newPage * filter.limit;

    if (totalSoFar <= newOffset) {
      fetchMoreAction({
        newPage,
        newOffset,
      });
    } else {
      dispatch(
        setFilters({
          filterId: filter.id,
          offset: newOffset,
          page: newPage,
        }),
      );
    }
  };
  return {
    handleChangePage,
  };
};

export default useMuiTablePaginate;
